// extracted by mini-css-extract-plugin
export default {"overlay":"CookieChecker_overlay__aOMqk","container":"CookieChecker_container__jieRi"};